import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/crud-helpers";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { PillTabsList, PillTabsTrigger } from "@/components/admin/pill-tabs";
import { Plug, Shield, Mail } from "lucide-react";
import { ProvidersPanel, AuthSettingsPanel, TemplatesPanel } from "@/components/admin/email-panels";

export const Route = createFileRoute("/_authenticated/admin/email-configurations")({
  component: EmailConfigurationsAdmin,
});

function EmailConfigurationsAdmin() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="Email Configurations"
        description="Sender identity, auth email behavior, transactional templates and the SMTP / HTTP providers used to send outgoing email."
      />
      <Tabs defaultValue="auth">
        <PillTabsList className="flex-wrap">
          <PillTabsTrigger value="auth"><Shield className="mr-1.5 h-3.5 w-3.5" />Auth & Sender</PillTabsTrigger>
          <PillTabsTrigger value="templates"><Mail className="mr-1.5 h-3.5 w-3.5" />Templates</PillTabsTrigger>
          <PillTabsTrigger value="providers"><Plug className="mr-1.5 h-3.5 w-3.5" />Providers</PillTabsTrigger>
        </PillTabsList>
        <TabsContent value="auth" className="mt-4"><AuthSettingsPanel /></TabsContent>
        <TabsContent value="templates" className="mt-4"><TemplatesPanel /></TabsContent>
        <TabsContent value="providers" className="mt-4"><ProvidersPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
